import { useRootNavigationState, useRouter, useSegments } from 'expo-router';
import { useEffect } from 'react';

const useProtectedRoute = (user: unknown, loading: boolean) => {
  const segments = useSegments();
  const router = useRouter();
  const navigationState = useRootNavigationState();

  useEffect(() => {
    const inAuthGroup = segments[0] === '(auth)';
    const inPatientGroup = segments[0] === 'patient';
    const inAppGroup = segments[0] === '(app)';

    if (navigationState?.key && !loading) {
      // Routes patient sont toujours accessibles sans authentification
      if (inPatientGroup) {
        return;
      }

      if (!user) {
        // Si pas connecté et pas dans auth ou patient, rediriger vers login
        if (!inAuthGroup && !inPatientGroup) {
          router.replace('/login');
        }
      } else {
        // Si connecté et dans auth ou page index vide, rediriger vers patients
        if (inAuthGroup || segments.length === 0) {
          router.replace('/patients');
        }
      }
    }
  }, [user, segments, navigationState?.key, loading]);
};

export default useProtectedRoute;
